import React from 'react';
import { useSelector } from 'react-redux';

import { allowDecimalByCountry } from 'user/selectors';

import { formatAvgYield } from 'util/formatters/numberFormatter';
import { getMessage } from 'util/locale';
import { inferUnit } from 'util/unitConversion';

const EstimatedYieldRow = ({
  originalAvgEstYield,
  activeAvgEstYield,
  yourPlanAvgEstYield
}: {
  originalAvgEstYield: number;
  activeAvgEstYield: number;
  yourPlanAvgEstYield: number;
}) => {
  const isDecimalCountry = useSelector(allowDecimalByCountry);

  return (
    <tr>
      <th role='rowheader'>
        {getMessage('estimated-yield')}{` (${inferUnit('area-density.yield').symbol.quantitySpecific})`}
      </th>
      <td>{formatAvgYield(yourPlanAvgEstYield, isDecimalCountry)}</td>
      <td>{formatAvgYield(originalAvgEstYield, isDecimalCountry)}</td>
      <td>{formatAvgYield(activeAvgEstYield, isDecimalCountry)}</td>
    </tr>
  );
};

export default EstimatedYieldRow;
